import { z } from 'zod';
import { UsStateCodeSchema } from './map-definition.js';
export const RecordStatusSchema = z.enum(['active', 'archived']);
export const AtlasRecordSchema = z.object({
    recordId: z.string().min(1),
    mapId: z.string().min(1),
    name: z.string().min(1).max(256),
    stateCodes: z.array(UsStateCodeSchema).min(1),
    status: RecordStatusSchema.default('active'),
    fields: z.record(z.unknown()).default({}),
    tags: z.array(z.string()).default([]),
    version: z.number().int().positive().default(1),
    createdAt: z.string().datetime(),
    createdBy: z.string().email(),
    updatedAt: z.string().datetime(),
    updatedBy: z.string().email(),
    archivedAt: z.string().datetime().nullable().default(null),
    archivedBy: z.string().email().nullable().default(null),
});
export const CreateRecordInputSchema = z.object({
    name: z.string().min(1).max(256),
    stateCodes: z.array(UsStateCodeSchema).min(1),
    fields: z.record(z.unknown()).default({}),
    tags: z.array(z.string()).default([]),
    status: z.enum(['active']).default('active'),
});
export const UpdateRecordInputSchema = z.object({
    expectedVersion: z.number().int().positive(),
    changes: z.object({
        name: z.string().min(1).max(256).optional(),
        stateCodes: z.array(UsStateCodeSchema).min(1).optional(),
        status: RecordStatusSchema.optional(),
        fields: z.record(z.unknown()).optional(),
        tags: z.array(z.string()).optional(),
    }),
});
export const AuditOperationSchema = z.enum([
    'Create',
    'Update',
    'Archive',
    'Restore',
    'ImportCreate',
    'ImportUpdate',
    'AdministrativeDelete',
]);
export const AuditVersionSchema = z.object({
    recordId: z.string(),
    mapId: z.string(),
    version: z.number().int().positive(),
    operation: AuditOperationSchema,
    userId: z.string(),
    userEmail: z.string().email(),
    timestamp: z.string().datetime(),
    previousValues: z.record(z.unknown()).nullable(),
    newValues: z.record(z.unknown()).nullable(),
    importId: z.string().nullable().optional(),
    requestId: z.string().optional(),
});
//# sourceMappingURL=record.js.map